var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ background: _vm.transparentBackground ? 'none' : '' }),attrs:{"id":"horizontal-hero"}})
}
var staticRenderFns = []

export { render, staticRenderFns }